export const officerVehicles = [
  '42C0820',
  '42C0822',
  '42C0742',
  '42C0868',
  '42C0126',
  '42C1261',
  '42C0830',
  '42C1278',
  '42C1099',
  // ---
  "42C1315",
  // '42C1274',
  // '42C1306',
  // '42C1100',
  // '42C0093',
  // '42C0388',
  // '42C1293',
  // '42C1327',
  // '42C0417',
  // '42C1004',
];
